import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useLazyGetBranchByUrlKeyQuery } from '../../../api/branchApi';
import { LoadingIndicator } from '../../shared/alerts/loadingIndicator';
import { Box, Typography } from '@mui/material';
import { Collection } from '../../../enums/collections.enum';

export const BranchByKeyContainer: React.FC = () => {
    const { branchKey } = useParams<{ branchKey: string }>();
    const navigate = useNavigate();
    const [notFound, setNotFound] = useState(false);
    const [getBranchByUrlKey] = useLazyGetBranchByUrlKeyQuery();

    useEffect(() => {
        if (!branchKey) {
            setNotFound(true);
            return;
        }
        getBranchByUrlKey(branchKey).then(result => {
            if (result.data) {
                navigate(`/${Collection.Companies}/${result.data.companyId}/${Collection.Branches}/${result.data.id}`, { replace: true });
            } else {
                setNotFound(true);
            }
        });
    }, [branchKey, navigate, getBranchByUrlKey]);

    if (notFound) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8 }}>
                <Typography variant="h6" color="text.secondary">Please check the web address and try again.
                </Typography>
            </Box>
        );
    }

    return <LoadingIndicator message="Loading branch..." />;
};
